/**
 * Safely resolves the WebSocket/Socket.io server base URL across Local & Production environments.
 * - Strips API subpaths (like /api) so Socket.io connects to the root namespace.
 * - Automatically upgrades to https: if the page is running over HTTPS to prevent Mixed Content blocking.
 * - Automatically connects to 'https://workora-api.fgrinfotech.com' when running on fgrinfotech.com domains.
 */
export function getSocketBaseUrl() {
  const envUrl = (import.meta.env.VITE_API_BASE_URL || '').trim().replace(/\/$/, '');

  // 1. Check if running in browser on production domain
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const host = window.location.hostname.toLowerCase();
    if (host.includes('fgrinfotech.com')) {
      return 'https://workora-api.fgrinfotech.com';
    }

    const isLocal = ['localhost', '127.0.0.1', '0.0.0.0'].includes(host);
    if (!isLocal) {
      if (envUrl && !envUrl.includes('localhost') && !envUrl.includes('127.0.0.1')) {
        try {
          const parsed = new URL(envUrl);
          if (window.location.protocol === 'https:' && parsed.protocol === 'http:') {
            parsed.protocol = 'https:';
          }
          return parsed.origin;
        } catch (_) {
          return envUrl;
        }
      }
      return window.location.origin;
    }
  }

  // 2. Local development fallback
  if (envUrl) {
    try {
      const parsed = new URL(envUrl);
      return parsed.origin;
    } catch (_) {
      return envUrl;
    }
  }

  return 'http://localhost:5000';
}
